import { createSelector } from "@reduxjs/toolkit";
import { SET_CLEARING_QUEUE, SET_PLAYBACK_ACTION, SET_SAVED_ALBUMS_LOADING_PROGRESS, SET_TOO_MANY_REQUESTS_COOLDOWN } from "../actions/disablingProcessesActions";

const checkLoadingProgressRunning = (loadingProgress) => {
    return loadingProgress !== undefined && loadingProgress !== 100
}

export const anyDisablingProcess = createSelector(
    state => state.disablingProcessesState,
    disablingProcessesState => 
        disablingProcessesState.playbackAction || 
        checkLoadingProgressRunning(disablingProcessesState.savedAlbumsLoadingProgress)  ||
        disablingProcessesState.clearingQueue
);

export const anyLongDisablingProcess = createSelector(
    state => state.disablingProcessesState,
    disablingProcessesState =>
        checkLoadingProgressRunning(disablingProcessesState.savedAlbumsLoadingProgress) ||
        disablingProcessesState.clearingQueue
);

export const playbackActionRunning = createSelector(
    state => state.disablingProcessesState,
    disablingProcessesState => disablingProcessesState.playbackAction
);

export const savedAlbumsLoading = createSelector(
    state => state.disablingProcessesState,
    disablingProcessesState => checkLoadingProgressRunning(disablingProcessesState.savedAlbumsLoadingProgress)
);

export const getSavedAlbumsLoadingProgress = createSelector(
    state => state.disablingProcessesState,
    disablingProcessesState => disablingProcessesState.savedAlbumsLoadingProgress
);

export const clearingQueueRunning = createSelector(
    state => state.disablingProcessesState,
    disablingProcessesState => disablingProcessesState.clearingQueue
);

export const getTooManyRequestsCooldown = createSelector(
    state => state.disablingProcessesState,
    disablingProcessesState => disablingProcessesState.tooManyRequestsCooldown
);

const INITIAL_STATE = {
    playbackAction: false,
    savedAlbumsLoadingProgress: undefined,
    clearingQueue: false,
    tooManyRequestsCooldown: 0
}

export const disablingProcessesState = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_PLAYBACK_ACTION:
            return {...state, playbackAction: action.payload};
        case SET_SAVED_ALBUMS_LOADING_PROGRESS:
            return {...state, savedAlbumsLoadingProgress: action.payload};
        case SET_CLEARING_QUEUE:
            return {...state, clearingQueue: action.payload};
        case SET_TOO_MANY_REQUESTS_COOLDOWN:
            return {...state, tooManyRequestsCooldown: action.payload};
        default:
            return state;
    }
}